import { useMemo } from 'react'

import { Box, Flex } from '@chakra-ui/react'
import { ItList, ItListChannel, User } from 'types/graphql'

import ItListCarousel from 'src/components/widgets/ItListCarousel/ItListCarousel'

const OtherItLists: React.FC<{
  itLists: ItList[]
  channels: ItListChannel[]
  creator: User
}> = ({ itLists, channels, creator }) => {
  const sortedItLists = useMemo(
    () => sortByAffinity(itLists, channels).map((il) => ({ ...il, creator })),
    [itLists, channels, creator]
  )
  return (
    <Flex
      direction="column"
      w={{ base: 'full', lg: '551px' }}
      pb={16}
      mx="auto"
      borderTop="1px solid"
      borderColor="vapor"
      pt={16}
    >
      <Box as="h4" className="thick" mb={6} ml={{ base: 4, lg: 0 }}>
        More from {creator.firstName}
      </Box>
      <ItListCarousel
        itLists={sortedItLists}
        itemsPerRow={2}
        showUsername={false}
      />
    </Flex>
  )
}

export function sortByAffinity(itLists: ItList[], channels: ItListChannel[]) {
  return itLists.sort(
    (il1, il2) =>
      affinity(il2.channels, channels) - affinity(il1.channels, channels)
  )
}

// Rules from https://itlist.atlassian.net/browse/WEB-891
function affinity(Il1Channels: ItListChannel[], Il2Channels: ItListChannel[]) {
  return Il1Channels.reduce((score, channel) => {
    const il2Channel = Il2Channels.find((ch) => ch.id === channel.id)
    if (!il2Channel) return score
    score += 5
    if (channel.isMain) {
      score += 10
    }
    if (il2Channel.isMain) {
      score += 20
    }
    if (channel.isMain && il2Channel.isMain) {
      score += 30
    }
    return score
  }, 0)
}

export default OtherItLists
